// Menú de móvil diferido (snippets/header-mobile-menu.liquid). La página trae solo los apartados
// principales; el menú completo llega por la Section Rendering API con la plantilla
// index.menu-movil, cuando el navegador está libre (si el botón del menú se ve) o al tocar el botón.
// Es el mismo HTML de siempre: los clics y los submenús los sigue gestionando scripts.js.
(() => {
  const list = document.querySelector("ul.navigation-mobile[data-menu-diferido]");
  if (!list) return;
  const sectionId = list.dataset.menuDiferido;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const url = root + "?view=menu-movil&sections=" + encodeURIComponent(sectionId);
  const cacheKey = "menu-movil:" + url;
  let pending = null;

  const apply = (itemsHtml) => {
    list.innerHTML = itemsHtml;
    list.removeAttribute("data-menu-diferido");
    // El menú se pide desde la portada: se marca el enlace de la página actual
    list.querySelectorAll("a[href]").forEach((link) => {
      const current = new URL(link.href, location.href).pathname === location.pathname;
      link.classList.toggle("current", current);
      if (current) link.setAttribute("aria-current", "page");
      else link.removeAttribute("aria-current");
    });
  };

  const load = () => {
    if (!list.hasAttribute("data-menu-diferido")) return Promise.resolve();
    if (pending) return pending;
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        apply(cached);
        return Promise.resolve();
      }
    } catch (error) {
      // Sin sessionStorage (modo privado): se pide siempre
    }
    pending = fetch(url, { credentials: "same-origin" })
      .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
      .then((sections) => {
        const doc = new DOMParser().parseFromString(sections[sectionId] || "", "text/html");
        const full = doc.querySelector("ul.navigation-mobile:not([data-menu-diferido])");
        if (!full || !full.children.length) return;
        apply(full.innerHTML);
        try {
          sessionStorage.setItem(cacheKey, full.innerHTML);
        } catch (error) {
          // Sin espacio o sin sessionStorage: no pasa nada
        }
      })
      .catch(() => {
        // Se queda con los apartados principales, que ya enlazan a cada sección
      })
      .finally(() => {
        pending = null;
      });
    return pending;
  };

  const toggle = document.querySelector(".head-slot-nav-mobile-link");
  if (toggle) {
    ["pointerdown", "focus", "mouseenter"].forEach((type) => toggle.addEventListener(type, load, { passive: true }));
  }
  document.addEventListener("mobile-menu:open", load);

  const whenIdle = () => {
    if (!toggle || toggle.offsetParent === null) return; // escritorio: el botón no se ve
    if ("requestIdleCallback" in window) requestIdleCallback(load, { timeout: 4000 });
    else setTimeout(load, 2000);
  };
  if (document.readyState === "complete") whenIdle();
  else window.addEventListener("load", whenIdle, { once: true });
})();
